import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8964dca8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "chooseEquipment h-full flex flex-col" }
const _hoisted_2 = { class: "conent" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title text-white font-medium" }, "选择机台", -1))
const _hoisted_4 = { class: "content_list content-start scrollBar" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "top flex items-center justify-between" }
const _hoisted_7 = { class: "text-white font-medium title-text" }
const _hoisted_8 = { class: "bottom font-normal flex items-center justify-between" }
const _hoisted_9 = { class: "equipment" }
const _hoisted_10 = { class: "onLineStatu" }
const _hoisted_11 = {
  key: 0,
  class: "triangle"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://djcps.oss-cn-hangzhou.aliyuncs.com/pro/djmes/select.png",
  alt: ""
}, null, -1))
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", null, null, -1))
const _hoisted_15 = { class: "footer flex justify-between items-center w-full text-center" }
const _hoisted_16 = {
  class: "create-creative",
  ref: "createCreative"
}
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "model-content font-medium" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "text-white" }, "机台生产中"),
  /*#__PURE__*/_createElementVNode("div", { class: "text-white chooseTips" }, "选中机台正在生产中，是否继续选择？")
], -1))
const _hoisted_18 = { class: "flex justify-between font-medium text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listData, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "item flex flex-col justify-between",
              key: index,
              onClick: ($event: any) => (_ctx.chooseEquipment(item)),
              style: _normalizeStyle(_ctx.activeIndedx == item.id && _ctx.LoginUserId == _ctx.userId ? _ctx.activeStyle : '')
            }, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, _toDisplayString(item.machineName), 1),
                _createElementVNode("div", {
                  class: "statu text-white text-center font-normal",
                  style: _normalizeStyle(item.state == 'rest' ? _ctx.restActive : item.state == 'free' ? _ctx.freeActive : '')
                }, _toDisplayString(item.state == 'producing' ? '生产中' : item.state == 'rest' ? '休息' : '空闲'), 5)
              ]),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, "绑定设备：" + _toDisplayString(item.equipmentName), 1),
                _createElementVNode("div", _hoisted_10, _toDisplayString(item.online ? '在线' : '未连接'), 1)
              ]),
              (_ctx.activeIndedx == item.id && _ctx.LoginUserId == _ctx.userId)
                ? (_openBlock(), _createElementBlock("div", _hoisted_11, _hoisted_13))
                : _createCommentVNode("", true)
            ], 12, _hoisted_5))
          }), 128)),
          _hoisted_14
        ])
      ]),
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("div", {
          class: "btn cancle",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.cancel && _ctx.cancel(...args)))
        }, "取消"),
        _createVNode(_component_a_button, {
          type: "primary",
          class: "btn next",
          onClick: _ctx.next,
          disabled: !(_ctx.listData.length > 0 && _ctx.parmas.machineId)
        }, {
          default: _withCtx(() => [
            _createTextVNode("下一步")
          ]),
          _: 1
        }, 8, ["onClick", "disabled"])
      ])
    ]),
    _createElementVNode("div", _hoisted_16, [
      _createVNode(_component_a_modal, {
        visible: _ctx.visible,
        "onUpdate:visible": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.visible) = $event)),
        getContainer: () => _ctx.createCreative,
        maskClosable: false,
        width: _ctx.$px2rem('540px'),
        centered: "",
        closable: false,
        "ok-text": "确认",
        "cancel-text": "取消"
      }, {
        footer: _withCtx(() => [
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("div", {
              class: "modelBtn cancel",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.modelCancel && _ctx.modelCancel(...args)))
            }, "取消"),
            _createElementVNode("div", {
              class: "modelBtn sure text-white",
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.modelSure && _ctx.modelSure(...args)))
            }, "确定")
          ])
        ]),
        default: _withCtx(() => [
          _hoisted_17
        ]),
        _: 1
      }, 8, ["visible", "getContainer", "width"])
    ], 512)
  ], 64))
}